export const toggleText = {
  toggleText: {
    showMore: 'show More',
    showLess: 'show Less',
  },
};
